import React, { useCallback, useState } from 'react';
import { Support } from '../../hooks/Support';
import Hls from 'hls.js';
import SwitchSummaryStyl from './SwitchSummary.styl';

export type SwitchSummaryProps = {
  enabled: boolean;
  hls: Hls;
  code: string;
  primaryColor: string;
  textColor: string;
  videoUrl: string;
  summaryVideoUrl: string;
};

const SwitchSummary = ({ enabled, hls, code, primaryColor, textColor, videoUrl, summaryVideoUrl }: SwitchSummaryProps) => {
  const [currentTimeVideo, setCurrentTimeVideo] = useState<number>(0);
  const [currentTimeSummaryVideo, setCurrentTimeSummaryVideo] = useState<number>(0);

  const changeSummary = useCallback((event: any) => {
    const rootElement = document.querySelector(`[data-code="${code}"] .smartplayer`) as HTMLDivElement;
    const videoElement = rootElement.querySelector('.smartplayer__airplay') as HTMLVideoElement;
    const captionsElement = rootElement.querySelector('.smartplayer__captions') as HTMLDivElement;

    if (event.target.checked) {
      rootElement.classList.add('smartplayer--summary-active');

      if (hls.media) {
        setCurrentTimeVideo(hls.media.currentTime);
        hls.loadSource(summaryVideoUrl);

        if (videoElement) {
          videoElement.src = summaryVideoUrl;
        }

        if (currentTimeSummaryVideo > 0) {
          hls.media.currentTime = currentTimeSummaryVideo;
        }

        if (captionsElement) {
          captionsElement.innerHTML = '';
        }

        hls.media.play();
      }

      return;
    }


    if (hls.media) {
      rootElement.classList.remove('smartplayer--summary-active');

      setCurrentTimeSummaryVideo(hls.media.currentTime);
      hls.loadSource(videoUrl);

      if (videoElement) {
        videoElement.src = videoUrl;
      }

      if (hls.subtitleTrack > -1) {
        hls.subtitleTrack = -1;
        const optionLanguage = rootElement.querySelector(`[name="subtitle"][value=""]`) as HTMLInputElement;

        if (optionLanguage) {
          optionLanguage.checked = true;
          optionLanguage.dispatchEvent(new Event('change'));
        }
      }

      if (currentTimeVideo > 0) {
        hls.media.currentTime = currentTimeVideo;
      }

      hls.media.play();
    }

    hls?.media?.dispatchEvent(new CustomEvent('summaryChange', { detail: { summary: event.target.checked } }));
  }, [hls, videoUrl, summaryVideoUrl, currentTimeVideo, currentTimeSummaryVideo]);

  if (!summaryVideoUrl) {
    return null;
  }

  return enabled ? (
    <SwitchSummaryStyl className="smartplayer__summary" primaryColor={primaryColor} textColor={textColor}>
      <label htmlFor={`${code}--summary`} className="smartplayer__button">
        <div className="smartplayer__switchWrapper">
          <input name={`${code}--summary`} id={`${code}--summary`} type="checkbox" className="smartplayer__switchCbx" onChange={changeSummary} />
          <label className="smartplayer__switch">
            <div className="smartplayer__switchCircle">
              <svg className="svg-inline--fa fa-bolt" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="bolt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg="" fill="currentColor">
                <path fill="currentColor" d="M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z">
                  <animate attributeName="fill" dur="5s" values={`${primaryColor};currentColor;${primaryColor}`} repeatCount="indefinite" />
                </path>
              </svg>
            </div>
          </label>
          <div className="smartplayer__switchBg"></div>
        </div>
      </label>
    </SwitchSummaryStyl>
  ) : null;
};

export default SwitchSummary;
